<template>
  <div id="home">
    <!-- 视频列表 -->
    <div class="content">
      <!-- 指定视频 -->
      <div class="stick">
        <div class="recommend"><span>今日推荐</span></div>
        <router-link
          v-if="videoList.length > 0"
          :to="{ path: 'video/' + videoList[0].id }"
        >
          <div v-if="videoList.length > 0">
            <img class="cover" :src="videoList[0].cover" alt="" />
            <div class="info">
              <div class="title">{{ videoList[0].title }}</div>
              <div class="views">
                <img src="https://oss.wlxww.com/fanzha/yan.png" />
                <span>{{ videoList[0].playbackNumber }}</span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="lists">
        <div class="recommend2"><span>观看有奖</span></div>
        <router-link
          v-for="(video, index) in videoList"
          :key="index"
          :to="{ path: 'video/' + video.id }"
        >
          <template v-if="index > 0">
            <div class="pi">
              <div class="list">
                <div class="poster">
                  <van-image height="100%" lazy-load :src="video.cover" />
                </div>
                <div class="info">
                  <div class="title">{{ video.title }}</div>
                  <div class="views-option">
                    <div class="views">
                      <img src="https://oss.wlxww.com/fanzha/yan.png" />
                      <span>{{ video.playbackNumber }}</span>
                    </div>
                    <div class="option">
                      <van-tag v-if="video.hasWatched != 1" type="primary" plain
                        >未观看</van-tag
                      >
                      <van-tag v-if="video.hasWatched == 1" type="success" plain
                        >已观看</van-tag
                      >
                    </div>
                  </div>
                </div>
                <!-- <div class="jie">
              <img src="https://oss.wlxww.com/fanzha/jie.png" alt="" />
            </div> -->
              </div>
            </div>
          </template>
        </router-link>
      </div>
    </div>

    <!-- 登记start -->
    <van-overlay :show="showSignModal" class="sign">
      <van-form @submit="doSign" class="sign-form">
        <div class="title">
          “为保障您在活动中的权益，请您务必填写真实的个人信息，【掌上温岭客户端】将对您的信息进行严格保密，请您放心填写！”
        </div>
        <van-field name="radio" label="身份">
          <template #input>
            <van-radio-group v-model="identity" direction="horizontal">
              <van-radio name="1">非学生</van-radio>
              <van-radio name="2">学生</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="identity == 1"
          required
          readonly
          clickable
          name="picker"
          :value="town"
          :label="'选择镇/街道/村'"
          :placeholder="'点击选择镇/街道/村'"
          @click="showTownPicker = true"
        />

        <van-field
          v-if="identity == 2"
          required
          readonly
          clickable
          name="picker"
          :value="town"
          :label="'选择镇/街道/学校'"
          :placeholder="'点击选择镇/街道/学校'"
          @click="showSchoolPicker = true"
        />
        <van-field
          v-if="identity > 0"
          required
          v-model="username"
          :label="'姓名'"
          :placeholder="'请输入姓名'"
        />
        <van-field
          v-if="identity > 0"
          required
          v-model="phone"
          :label="'手机号码'"
          :placeholder="'请输入手机号码'"
        />
        <van-popup v-model="showTownPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="townVillage"
            @confirm="onConfirm"
            @cancel="showTownPicker = false"
            @change="onChange"
          />
        </van-popup>

        <van-popup v-model="showSchoolPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="townSchool"
            @confirm="onConfirm"
            @cancel="showSchoolPicker = false"
            @change="onChange2"
          />
        </van-popup>

        <div class="sign-btn">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            :disabled="!identity || !town || !phone || !username"
            >提交</van-button
          >
        </div>
      </van-form>
    </van-overlay>
    <van-overlay :show="showPoster" @click="showPoster = false">
      <div class="hb">
        <div class="content">
          <img :src="posterUrl" width="100%" />
          <van-icon name="cross" size="25" @click="showPoster = false" />
        </div>
      </div>
    </van-overlay>
    <!-- 登记end -->
  </div>
</template>

<script>
import Vue from "vue";
import "video.js/dist/video-js.css";

import videojs from "video.js";
import { Lazyload, Dialog, Overlay } from "vant";

import VueLuckyCanvas from "@lucky-canvas/vue";
import { getVideoList } from "@/api/fanzha";
import { getArea } from "@/api/fanzha";
import { saveUser } from "@/api/fanzha";
import { getFanzhaUserInfo } from "@/api/fanzha";

Vue.use(Lazyload);
Vue.use(VueLuckyCanvas);

export default {
  name: "List",
  data() {
    return {
      themeId: 2,
      showPoster: false,
      posterUrl: "",
      paichusuo: "",
      username: "",
      phone: "",
      showTownPicker: false,
      showSchoolPicker: false,
      townVillage: [],
      townSchool: [],
      identity1: {},
      identity2: {},
      showSignModal: false,
      town: "", // 镇街
      identity: "", // 身份 1 = 学生 2 = 非学生
      levelTwo: "",
      levelTwos: [],
      showLevelTwoPicker: false,
      currentIdentity: [],
      identityName: "",
      videoList: [],
    };
  },
  created() {
    //加载视频列表
    getVideoList({ themeId: this.themeId }).then((res) => {
      if (res.code == 1) {
        this.videoList = res.data;
      }
    });

    if (this.getCookie("popped2") == "") {
      //cookie 中没有 popped 则赋给他一个值（此时弹框显示）
      document.cookie = "popped2 = yes";
      Dialog.alert({
        message:
          "活动于2月8日结束，请点击右上角查看【我的奖品】，中奖者须在规定时间内前往指定地点领取奖品，逾期未领取将视为放弃领取！",
      });
    }
  },
  watch: {
    identity(val, oldVal) {
      console.log(val);
      if (val !== oldVal) {
        this.town = "";
        if (val == 1) {
          this.showSchoolPicker = false;
        } else {
          this.showTownPicker = false;
        }
      }
    },
  },
  mounted() {
    getFanzhaUserInfo({ themeId: this.themeId }).then((res) => {
      if (res.code == 1 && res.data == null) {
        this.showSignModal = true;
      }
    });
    getArea().then((res) => {
      if (res.code == 1) {
        this.identity1 = res.data.townVillage;
        this.identity2 = res.data.townSchool;
        this.townVillage = [
          { values: Object.keys(this.identity1) },
          { values: this.identity1["太平街道"] },
        ];
        this.townSchool = [
          { values: Object.keys(this.identity2) },
          { values: this.identity2["太平街道"] },
        ];
      }
    });
  },
  methods: {
    getCookie(Name) {
      //cookie
      var search = Name + "=";
      var returnValue = "";
      if (document.cookie.length > 0) {
        var offset = document.cookie.indexOf(search);
        if (offset !== -1) {
          offset += search.length;
          var end = document.cookie.indexOf(";", offset);
          if (end == -1) {
            end = document.cookie.length;
          }
          returnValue = decodeURIComponent(
            document.cookie.substring(offset, end)
          );
        }
      }
      return returnValue;
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.identity1[values[0]]);
    },
    onChange2(picker, values) {
      picker.setColumnValues(1, this.identity2[values[0]]);
    },
    onConfirm(value, index) {
      this.town = value.toString();
      this.showTownPicker = false;
      this.showSchoolPicker = false;
    },
    doSign() {
      // 用户登记
      var params = {
        username: this.username,
        town: this.town,
        isStudent: this.identity,
        phone: this.phone,
        themeId: this.themeId,
      };
      // console.log(params);
      saveUser(params).then((res) => {
        if (res.code == 1) {
          this.showSignModal = false;
          //登记完之后还得弹出派出所的标语跟海报
          Dialog.alert({
            message:
              '<div style="font-size:18px">放心吧！你的钱袋子由我们<br><b>' +
              res.data.paichusuo +
              "</b>守护<div>",
          });
          this.paichusuo = res.data.paichusuo;
          this.posterUrl = res.data.poster;
          this.showPoster = true;
        } else {
          Dialog.alert({
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: #000;
}

.sign {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .sign-form {
    width: 80vw;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    .title {
      color: #000;
    }
  }
  .sign-btn {
    margin-top: 10px;
  }
}

.hb {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .content {
    width: 80vw;
    margin: auto;
    text-align: center;
    .pcs-highlight {
      font-weight: bold;
      font-size: 25px;
    }
  }
}

.stick {
  padding-bottom: 10px;
  .recommend {
    text-align: left;
    font-weight: bold;
    background-image: url("https://oss.wlxww.com/fanzha/jrtj.png");
    background-size: 4.2%, 4.2%;
    background-repeat: no-repeat;
    background-position: 0;
    color: #fadab5;
    margin-bottom: 10px;
    span {
      padding-left: 5%;
    }
  }
  .cover {
    border: 4px solid #fadab5;
    border-radius: 15px;
    box-sizing: border-box;
    width: 100%;
  }
  .info {
    display: flex;
    justify-content: space-between;
    color: #fff;
    padding: 0 10px;
    .views {
      flex: 0 0 25%;
      text-align: right;
    }
    img {
      width: 20px;
      vertical-align: text-bottom;
    }
    span {
      padding-left: 5px;
    }
  }
}

.lists {
  margin-top: 10px;
  .recommend2 {
    text-align: left;
    font-weight: bold;
    background-image: url("https://oss.wlxww.com/fanzha/gkyj.png");
    background-size: 4.2%, 4.2%;
    background-repeat: no-repeat;
    background-position: 0;
    margin-bottom: 10px;
    color: #fadab5;
    span {
      padding-left: 5%;
    }
  }
  .pi {
    color: #b31111;
    background-color: #fff8e1;
    padding: 3px;
    border-radius: 10px;
    margin-bottom: 15px;
    .list {
      position: relative;
      display: inline-flex;
      padding: 10px 0 10px 10px;
      border: 1px solid #eb2b2b;
      border-radius: 10px;
      .poster {
        flex: 0 0 40%;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .info {
        flex: 1;
        // color: #fff;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          width: 80%;
          font-size: 14px;
        }
        .views-option {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // margin-top: 10px;
          .views {
            flex: 0 0 50%;
            line-height: 20px;
            img {
              width: 20px;
              vertical-align: text-bottom;
            }
            span {
              margin-left: 5px;
            }
          }
          .option {
            text-align: right;
            padding-right: 10px;
          }
        }
      }
      .jie {
        position: absolute;
        right: 5px;
        top: 0;
        width: 10%;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
